export function pluralize(
  count: number,
  word: string,
  { addCount = false }: { addCount?: boolean } = {}
) {
  let plural = word
  if (count !== 1) {
    plural = `${word}s`
  }

  if (addCount) {
    return `${count} ${plural}`
  }
  return plural
}

export function truncateSentence(
  text: string,
  limit: number,
  { avoidWordCut = true }: { avoidWordCut?: boolean } = {}
) {
  if (!text) {
    return ''
  }

  if (text.length <= limit) {
    return text
  }

  if (!avoidWordCut) {
    return `${text.slice(0, limit)}...`
  }

  let end = text.lastIndexOf(' ', limit)
  if (end === -1) {
    end = limit
  }
  return `${text.slice(0, end)}...`
}
